export default "__VITE_ASSET__CzA9ZSCi__"